
import React from 'react';
import Lottie from 'lottie-react';

interface LottieAnimationProps {
  animationData?: any;
  animationUrl?: string;
  loop?: boolean;
  autoplay?: boolean;
  className?: string;
  onComplete?: () => void;
  trigger?: boolean;
}

const LottieAnimation = ({
  animationData,
  animationUrl,
  loop = false,
  autoplay = true,
  className = "",
  onComplete,
  trigger = true
}: LottieAnimationProps) => {
  // Enhanced mock animation data for the new quiz paths
  const mockGlowPulse = {
    v: "5.7.4",
    fr: 30,
    ip: 0,
    op: 90,
    w: 200,
    h: 200,
    nm: "Glow Pulse Enhanced",
    ddd: 0,
    assets: [],
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "Glow",
      sr: 1,
      ks: {
        o: { a: 1, k: [
          { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [20] },
          { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [100] },
          { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 60, s: [80] },
          { t: 90, s: [20] }
        ]},
        r: { a: 1, k: [
          { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0] },
          { t: 90, s: [360] }
        ]},
        p: { a: 0, k: [100, 100, 0] },
        a: { a: 0, k: [0, 0, 0] },
        s: { a: 1, k: [
          { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [70, 70, 100] },
          { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [130, 130, 100] },
          { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 60, s: [100, 100, 100] },
          { t: 90, s: [70, 70, 100] }
        ]}
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: { a: 0, k: [100, 100] },
          p: { a: 0, k: [0, 0] },
          nm: "Ellipse Path"
        }, {
          ty: "fl",
          c: { a: 0, k: [1, 0.737, 0.612, 1] },
          o: { a: 0, k: 100 },
          r: 1,
          bm: 0,
          nm: "Fill"
        }, {
          ty: "st",
          c: { a: 0, k: [1, 0.592, 0.455, 1] },
          o: { a: 0, k: 60 },
          w: { a: 0, k: 3 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke"
        }],
        nm: "Ellipse",
        bm: 0
      }],
      ip: 0,
      op: 90,
      st: 0,
      bm: 0
    }]
  };

  const defaultAnimationData = animationData || mockGlowPulse;

  if (!trigger) return null;

  return (
    <div className={className}>
      <Lottie
        animationData={defaultAnimationData}
        loop={loop}
        autoplay={autoplay}
        onComplete={onComplete}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};

export default LottieAnimation;
